import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Palette, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin/panel");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block overflow-hidden grain">
        <img
          src="https://images.unsplash.com/photo-1562541996-dc329febcdbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxuZW9uJTIwc2lnbiUyMGFydHxlbnwwfHx8fDE3ODY5ODEyMzV8MA&ixlib=rb-4.1.0&q=85"
          alt="Neón Bspark"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative h-full flex flex-col justify-end p-14 text-white">
          <p className="uppercase tracking-[0.3em] text-xs text-white/70 mb-4">BSpark Family Hub · Panel interno</p>
          <h2 className="font-display text-5xl font-extrabold leading-[1.05] neon-text">
            El secreto para dibujar es poner la línea correcta en el lugar correcto.
          </h2>
          <p className="mt-6 text-white/70 max-w-md text-sm">
            Panel interno de gestión de alumnos, clases, profesores y sedes.
          </p>
        </div>
      </div>

      <div className="flex items-center px-6 sm:px-16 py-16">
        <div className="w-full max-w-sm fade-up">
          <div className="h-11 w-11 rounded-xl bg-primary grid place-items-center mb-8">
            <Palette className="h-6 w-6 text-primary-foreground" />
          </div>
          <h1 className="font-display text-4xl font-extrabold">Acceso interno</h1>
          <p className="text-muted-foreground text-sm mt-2 mb-8">
            Acceso para el equipo de Bspark. Las familias entran desde la{" "}
            <a href="/" className="text-primary font-semibold">página de inicio</a>.
          </p>

          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@bspark.es"
                data-testid="login-email-input"
                className="rounded-lg h-11"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Contraseña</Label>
              <PasswordInput
                id="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="rounded-lg h-11"
              />
            </div>
            {error && (
              <p className="text-sm text-destructive font-medium" data-testid="login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-11 rounded-full font-semibold transition-transform duration-200 hover:-translate-y-[1px]"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entrar"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
